/**
 * @relyo/web – Web-SDK für Relyo Co-Browsing (Code, Consent, Live-Streaming, Redaction,
 * Annotationen, Remote Control).
 */
import { RelyoClient, type RelyoInstance } from './client';
import { SDK_VERSION } from './constants';
import type { RelyoOptions } from './options';

export type { RelyoInstance } from './client';
export type { ConnectMode, RelyoOptions, RelyoUser, StatusPosition } from './options';
export { formatCode } from './format';

let current: RelyoClient | null = null;

/**
 * Initialisiert das SDK. Pro Seite gibt es genau eine Instanz; ein zweiter Aufruf ohne
 * vorheriges `destroy()` liefert die bestehende Instanz zurück.
 */
export function init(options: RelyoOptions): RelyoInstance {
  if (typeof window === 'undefined' || typeof document === 'undefined') {
    throw new Error('Relyo.init: nur im Browser aufrufbar (z. B. in useEffect)');
  }
  if (current && !current.isDestroyed) {
    console.warn('[relyo] Relyo.init wurde mehrfach aufgerufen – bestehende Instanz wird genutzt.');
    return current;
  }
  current = new RelyoClient(options);
  return current;
}

export const version = SDK_VERSION;

/**
 * Namespace-Objekt: `import { Relyo } from '@relyo/web'; Relyo.init({...})`.
 * Im IIFE-Build ist das Modul selbst der globale `Relyo` – dort gilt `window.Relyo.init(...)`.
 */
export const Relyo = { init, version } as const;
